import React, {useMemo} from "react";
import {Stats, TextSkeleton} from "peggirkit";
import StatItem from "peggirkit/dist/components/Stats/StatsElements/StatItem";
import {FormattedMessage, useIntl} from "react-intl";
import {formatDate, HhMm, minutesToHhMm} from "@/utils/DateUtils";
import {getTimeDifference, TimeDiff} from "@widgets/employees/editor/timeEntries/columns/WorkedHoursSummaryFormatter";
import {EmployeeInReport, EmployeeTimeEntry} from "@/data/entities/employee";
import {DateRange} from "react-day-picker";

type Props = {
    dateRange: DateRange,
    data: EmployeeInReport[] | undefined,
};

const TimesheetStats = ({data, dateRange}: Props) => {
    const intl = useIntl();
    const formattedRange = useMemo(
        () => intl.formatMessage({id: "dateRange"}, {
            from: formatDate(dateRange.from),
            to: formatDate(dateRange.to)
        }),
        [intl, dateRange]);
    const {hours: workedHours, minutes: workedMinutes}: HhMm = useMemo(() => {
        let total = 0;

        if (data === undefined) {
            return minutesToHhMm(total);
        }

        data.map((e: EmployeeInReport) =>
            e.timeEntries.map((entry: EmployeeTimeEntry) => {
                const diff: TimeDiff | null = getTimeDifference(entry)
                total += diff?.workedMinutes || 0
            })
        )

        return minutesToHhMm(total);
    }, [data]);

    return (
        <Stats
            size={"xs"}
            itemsPerRow={1}
            breakpoints={{
                xs: {
                    itemsPerRow: 2,
                },
                xl: {
                    itemsPerRow: 3,
                    size: "sm",
                },
            }}
        >
            <StatItem
                name={<FormattedMessage id={"period"}/>}
                value={formattedRange}
            />

            <StatItem
                name={<FormattedMessage id={"workedHours"}/>}
                value={
                    data === undefined
                        ? <TextSkeleton className={"h-7 max-w-[120px]"}/>
                        : <FormattedMessage
                            id={"formattedHoursMinutes"}
                            values={{
                                hours: workedHours,
                                minutes: workedMinutes,
                            }}
                        />
                }
            />

            <StatItem
                name={<FormattedMessage id={"numberOfEmployees"}/>}
                value={
                    data === undefined
                        ? <TextSkeleton className={"h-7 max-w-[90px]"}/>
                        : data.length
                }
            />
        </Stats>
    );
};

export default TimesheetStats;